<template>
    <div class="container position-relative text-center pt-4">

        <h1 v-if="logged">
            Welcome {{ username }}
        </h1>

        <p v-if="logged" class="position-absolute top-0 end-0 mt-3">
            <a href="#" @click.prevent="logout">&raquo; Log out</a>
        </p>
        <div v-if="logged" class="row justify-content-center mb-4">
            <div v-if="abyachtsEnabled" class="col-6 col-sm-4">
                <img src="@/assets/ab-yachts-logo.jpg" class="img-fluid btn-start" alt="AB Yachts" @click="(!isOffline) ? setSection('ab-yachts') : null" />
                <button v-if="isOffline && offlineItems" class="btn btn-dark w-100 btn-start mt-3" @click="launchSection('ab-yachts')">
                    Start AB Yachts 
                    <span v-if="needtoupdate">without updating</span>
                    <span v-if="offlineMode">offline</span>
                </button>
            </div>
            <div v-if="maioraEnabled" class="col-6 col-sm-4">
                <img src="@/assets/maiora-logo.jpg" class="img-fluid btn-start" alt="Maiora" @click="(!isOffline) ? setSection('maiora') : null" />
                <button v-if="isOffline && offlineItems" class="btn btn-dark w-100 btn-start mt-3" @click="launchSection('maiora')">
                    Start Maiora 
                    <span v-if="needtoupdate">without updating</span>
                    <span v-if="offlineMode">offline</span>
                </button>
            </div>
        </div>

        <div v-if="(!logged || edit) && !showFormRequest" class="row justify-content-center">
            
            <h2 class="mb-3" v-if="!logged">Log in</h2>
            <h2 class="mb-3" v-if="edit">Edit Username / Password</h2>
            
            <form class="col-12 col-sm-6">
                <p>
                    <label class="form-label" for="email">
                        Username:
                    </label>
                    <input type="text" v-model="useremail" id="email" class="form-control" @keyup="resetError" autocomplete="email">
                </p>
                <p v-if="edit">
                    <label class="form-label" for="oldpassword">
                        Old Password:
                    </label>
                    <input type="password" v-model="userpassword" id="oldpassword" class="form-control" @keyup="resetError" autocomplete="new-password">
                </p>
                <p>
                    <label class="form-label" for="password">
                        <span v-if="edit">New </span>Password:
                    </label>
                    <input type="password" v-model="userpassword" id="password" class="form-control" @keyup="resetError" autocomplete="new-password">
                </p>
                <p v-if="!logged">
                    <label>
                        <input type="checkbox" value="1" id="rememberme" v-model="rememberme">
                        Remember access data
                    </label>
                </p>
                <p>
                    <button type="button" v-if="!logged" class="btn btn-danger my-2" @click="logIn">Log in</button>
                    <button type="button" v-if="edit" class="btn btn-danger my-2 mx-2" @click="saveUser">Save changes</button>
                    <button type="button" v-if="edit" class="btn btn-secondary my-2 mx-2" @click="stopEdit">Cancel</button>
                </p>
            </form>
        </div>

        <div v-if="!logged && !isOffline" :class="['row justify-content-center', showBrokerRequest ? '' : 'd-none']">

            <hr v-if="!showFormRequest" class="my-5" />
            
            <h2 class="mb-3">Request access</h2>
            <h3 class="mt-4" v-if="!showFormRequest && !requestmsg">
                If You're a Broker and want to access Sales App, <br />
                please <a href="#" @click.prevent="showRequest">fill in this form</a>.
            </h3>

            <div v-if="requestmsg" class="mt-4">
                <div class="alert alert-success d-inline-block">
                    <p v-html="requestmsg"></p>
                </div>
            </div>
            
            <form class="col-12 col-sm-8 text-start mt-4" v-if="showFormRequest && !requestmsg" action="login/requestAccess" @submit="sendRequest">
                <p class="text-center fst-italic">
                    Fields marked with an asterisk <span class="text-danger">*</span> are mandatory.
                </p>
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label" for="firstname">
                        First name: <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-8">
                        <input type="text" v-model="input.firstname" id="firstname" class="form-control" placeholder="Your name" @keyup="resetError" required>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label" for="lastname">
                        Last name: <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-8">
                        <input type="text" v-model="input.lastname" id="lastname" class="form-control" placeholder="Your surname" @keyup="resetError" required>
                    </div>
                </div>
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label" for="company">
                        Company:
                    </label>
                    <div class="col-sm-8">
                        <input type="text" v-model="input.company" id="company" class="form-control" placeholder="Your company" @keyup="resetError">
                    </div>
                </div>
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label" for="phone">
                        Phone number:
                    </label>
                    <div class="col-sm-8">
                        <input type="text" v-model="input.phone" id="phone" class="form-control" placeholder="Your phone number">
                    </div>
                </div>
                <div class="mb-3 row">
                    <label class="col-sm-4 col-form-label" for="newemail">
                        Your email: <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-8">
                        <input type="email" v-model="input.email" id="newemail" class="form-control" placeholder="The email used to access the App" autocomplete="email" required>
                    </div>
                </div>
                <div class="mb-4 row">
                    <label class="col-sm-4 col-form-label" for="newpassword">
                        <span v-if="edit">New </span>Password: <span class="text-danger">*</span>
                    </label>
                    <div class="col-sm-8">
                        <input type="password" v-model="input.password" id="newpassword" class="form-control" placeholder="The password used to access the App" @keyup="resetError" autocomplete="new-password">
                    </div>
                </div>
                <div class="mb-3">
                    I declare that I have read the <a href="https://www.nextyachtgroup.com/en/privacy-policy?_gl=1*rg70vr*_up*MQ..*_ga*NjgwNTQxOTkzLjE3NjM0OTIyMzY.*_ga_WSW1H4C3W2*czE3NjM0OTIyMzYkbzEkZzAkdDE3NjM0OTIyNDUkajUxJGwwJGgw" target="_blank">Privacy Policy</a> and in relation to it:
                </div>
                <div class="mb-3">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="input.marketingAllow" id="marketingAllow" required>
                        <label class="form-check-label" for="marketingAllow">
                            I consent to receive, via email, from the Data Controller, informational material about their products for the purpose of managing my request. <span class="text-danger">*</span>
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" v-model="input.nlApprove" id="nlApprove">
                        <label class="form-check-label" for="nlApprove">
                            I give my consent to receive the newsletter from the Data Controller about the world of Next Yacht Group and the AB YACHTS and MAIORA brands.
                        </label>
                    </div>
                </div>
                <div class="mb-4">
                    You can unsubscribe from these communications at any time.
                </div>
                <div class="text-center">
                    <button type="button" :class="['btn btn-danger my-2', (input.marketingAllow) ? '' : 'disabled']" @click="sendRequest">Send request</button>
                </div>
            </form>
        </div>

        <div class="mt-3" v-if="errormsg">
            <div class="alert alert-danger d-inline-block">
                <p class="mb-0" id="errormsg">
                    {{ errormsg }}
                    <a v-if="arrErrors.length" class="ms-1" data-bs-toggle="collapse" href="#collapseErrors" role="button" aria-expanded="false" aria-controls="collapseErrors">
                        (details)
                    </a>
                </p>
                <ul v-if="arrErrors.length" class="collapse mt-2 text-start" id="collapseErrors">
                    <li v-for="(path, index) in arrErrors" :key="index">
                        {{ path.substr(7) }}
                    </li>
                </ul>
            </div>
        </div>

        <button v-if="logged && isOffline && needtoupdate" class="btn btn-danger my-2" @click="(downloading) ? stopDownloading() : downloadFiles()">
            <span v-if="downloading">Stop downloading</span>
            <span v-else>Download files</span>
        </button>

        <div id="result-box">
            <div id="result" class="result"></div>
        </div>

    </div>

    <div class="text-center my-4" id="footer">
        <p class="mb-2">App version: {{ appVersion }}</p>
        <div><small>A brand of NEXT YACHT GROUP - Lungocanale Palombari dell'Artiglio 41 - 55049 Viareggio (LU) - Italy</small></div>
    </div>

</template>

<script>
export default {
    name: 'LoginPage',
    data() {
        return {
            appVersion: this.$store.getters.appVersion,
            isOffline: global.isOffline,
            offlineMode: false,
            pendingupdate: false,
            edit: false,
            showFormRequest: false,
            showBrokerRequest: false,
            errormsg: null,
            requestmsg: null,
            checked: false,
            mode: 'indeterminate',
            downloadperc: 0,
            useremail: this.$store.getters['login/email'],
            userpassword: this.$store.getters['login/password'],
            rememberme: this.$store.getters['login/rememberme'],
            input: {
                email: '',
                password: '',
                firstname: '',
                lastname: '',
                company: '',
                phone: '',
                marketingAllow: false,
                nlApprove: false
            }
        }
    },
    computed: {
        logged() {
            return this.$store.getters['login/isLogged']
        },
        /* useremail() {
            return this.$store.getters['login/email']
        },
        userpassword() {
            return this.$store.getters['login/password']
        },
        userrememberme() {
            return this.$store.getters['login/rememberme']
        }, */
        username() {
            return this.$store.getters['login/username']
        },
        maioraEnabled() {
            return this.$store.getters['login/maioraEnabled']
        },
        abyachtsEnabled() {
            return this.$store.getters['login/abyachtsEnabled']
        },
        pageItems() {
            return this.$store.getters['filelist/pageItems']
        },
        offlineItems() {
            return this.$store.getters['filelist/offlineItems']
        },
        needtoupdate() {
            return this.$store.getters['filelist/needtoupdate']
        },
        arrErrors() {
            return this.$store.getters['filelist/arrErrors']
        },
        filesMissing() {
            return this.$store.getters['filelist/filesMissing']
        },
        downloading() {
            return this.$store.getters['filelist/downloadStarted']
        }
    },
    methods: {
        launchSection(section) {
            console.log("launchSection", section)
            this.$store.dispatch('launchSection', section).then(() => {
                this.$store.dispatch('goHome')
            })
        },
        setSection(section) {
            console.log("setSection", section)
            this.$store.dispatch('setSection', section)
        },
        async logIn() {
            this.resetError()
            this.$store.dispatch("writeLog", "=> LOGIN", { root: true})
            let data = {
                email: this.useremail,
                password: this.userpassword,
                rememberme: this.rememberme
            }
            await this.$store.dispatch('login/login', data).then((response) => {
                console.log('Login response', response)
                if (!response.token) {
                    this.$store.dispatch("writeLog", "### Login error: "+ response, { root: true})
                    if (response.message == "Network Error") {
                        this.errormsg = "You're Offline! Check you Internet connection."
                        this.offlineMode = true
                        return false
                    }
                    this.errormsg = response
                } else {
                    this.errormsg = null
                    this.getPageItems()
                    if (this.isOffline) window.top.ipcRenderer.send('checkAppUpdates')
                }
            })
        },
        logout() {
            this.$store.dispatch("writeLog", "=> Log out "+ this.username, { root: true})
            this.$store.dispatch('login/logout')
            this.errormsg = null
        },
        showRequest() {
            this.showFormRequest = true
        },
        validEmail: function (email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        async sendRequest(event) {
            event.preventDefault()
            if (!this.input.marketingAllow) {
                return false
            }
            this.resetError()
            if (!this.input.firstname || !this.input.lastname || !this.input.email || !this.input.password) {
                this.errormsg = "Please, fill in all required fields!"
                return false
            }
            if (this.input.email && !this.validEmail(this.input.email)) {
                this.errormsg = "A valid email is required!"
                return false
            }
            this.$store.dispatch("writeLog", "=> REQUEST ACCESS FROM "+ this.input.email, { root: true})
            let data = {
                email: this.input.email,
                password: this.input.password,
                firstname: this.input.firstname,
                lastname: this.input.lastname,
                company: this.input.company,
                phone: this.input.phone,
                nlApprove: this.input.nlApprove,
            }
            await this.$store.dispatch('login/requestAccess', data).then((response) => {
                console.log('requestAccess response', response)
                if (response !== 'OK') {
                    this.errormsg = response
                } else {
                    this.errormsg = null
                    this.requestmsg = "Request sent correctly!<br />Please, wait for our Team response before trying to access again."
                }
            })
        },
        resetError() {
            this.errormsg = null
            this.requestmsg = null
        },
        async getPageItems() {
            this.$store.dispatch("writeLog", "=> getPageItems", { root: true})
            await this.$store.dispatch('filelist/getPageItems').then((response) => {
                if (response.error) {
                    console.log('response', response)
                    this.$store.dispatch("writeLog", "### Get items error: "+ response.error, { root: true})
                    if (response.error == "Network Error") {
                        this.errormsg = "You're Offline! Check you Internet connection."
                        this.offlineMode = true
                        return false
                    }
                    if (response.error == "User not found!") {
                        this.$store.dispatch('login/logout')
                        this.errormsg = "Please, login again"
                        return false
                    }
                    this.errormsg = response.error
                    return false
                } else {
                    this.errormsg = null
                    this.offlineMode = false
                    if (response && global.isOffline) {
                        this.$store.dispatch('filelist/checkFiles', response).then(() => {
                            //console.log("rewritePath response", rewriteresponse)
                            let missing = this.filesMissing.length
                            if (missing) {
                                this.errormsg = "There are "+ missing +" files missing!"
                                return false
                            }
                        })
                    }
                    /* if (this.maioraEnabled && !this.abyachtsEnabled) this.setSection('maiora')
                    if (!this.maioraEnabled && this.abyachtsEnabled) this.setSection('ab-yachts') */
                }
            })
        },
        getErrors() {
            if (this.arrErrors.length) {
                this.$store.dispatch("writeLog", "### "+ this.arrErrors.length +" file/s couldn't be downloaded!", { root: true})
                this.errormsg = this.arrErrors.length +" file/s couldn't be downloaded!"
            }
            return null
        },
        async downloadFiles() {
            this.errormsg = null
            await this.$store.dispatch('filelist/updateFiles').then(() => {
                this.getErrors()
            })
        },
        stopDownloading() {
            this.$store.dispatch('filelist/cancelDownload')
            let missing = this.filesMissing.length
            if (missing) {
                this.errormsg = "There are "+ missing +" files missing!"
                return false
            }
        }
    },
    updated() {
        console.log("PAGE UPDATED")
        this.getErrors()
    },
    mounted() {
        this.$nextTick(function () {
            if (!global.isOffline) return 
            //Register IPC Renderer event handles once for this control
            window.top.ipcRenderer.on('logout', () => {
                this.logout()
            });
            window.top.ipcRenderer.on('message', (event, data) => {
                //console.log('message received', data);
                const resultBox = document.getElementById('result')
                resultBox.innerText = data
            });
        });
    },
    created() {
        this.setSection(null)
        document.body.classList.remove('yacht-page')
        if (this.isOffline && this.logged && !this.offlineMode) window.top.ipcRenderer.send('checkAppUpdates')
        if (this.logged && !this.pageItems.length) {
            this.getPageItems()
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#content {
    min-height: 100vh;
    padding-bottom: 110px;
}
h1 {
    margin-bottom: 40px;
}
.online .btn-start {
    cursor: pointer;
}
.offline .btn-start {
    max-width: 265px;
    border-radius: 0;
}
#footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
}
#next-yacht-group {
    width: 70px;
}
</style>
